module.exports = __webpack_public_path__ + "static/valinor-logo-837d21cf4ed4de256b8ea894d9fc982a.png";